/**
 * Handler for the browse_templates AI function.
 *
 * Fetches showcase templates from the API and displays them
 * as a horizontal slider widget in the chat.
 */
export const handleBrowseTemplates = async ($message, { commit, dispatch }) => {
  try {
    const { data: templates } = await axios.get('/networks/templates');

    if (!templates || templates.length === 0) {
      await dispatch('addAndSaveMessage', {
        role: 'assistant',
        content: 'No templates available yet. To show templates here, tag them with <b>&nbsp;creative_studio&nbsp;</b> in the template editor.',
      });
      return;
    }

    commit('SET_SHOWCASE_TEMPLATES', templates);

    await dispatch('addAndSaveMessage', {
      role: 'assistant',
      content: 'Here are your available templates. Pick a style to start with:',
      widgets: [
        {
          type: 'template_slider',
          id: 'template_browse',
          templates: templates.map((t) => ({
            id: t.id,
            name: t.name,
            thumbnail: t.thumbnail,
            width: t.width,
            height: t.height,
            tags: t.tags,
          })),
        },
      ],
    });
  } catch (e) {
    await dispatch('addAndSaveMessage', {
      role: 'assistant',
      content: 'Failed to load templates. Please try again.',
    });
  }
};
